import React from "react"
import { withTranslation } from "gatsby-plugin-react-i18next"
import styled from "styled-components"
import ReactPopup from "reactjs-popup"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"
import CloseIcon from "../../resources/img/ui/popup/close-green-thin.svg"

const overlayStyle = {
  overflowY: "auto",
  background: "rgba(0, 0, 0, 0.25)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}

const contentStyle = {
  maxWidth: "1000px",
  width: "100%",
  background: `${colors.beige}`,
  marginLeft: "16px",
  marginRight: "16px",
  padding: "40px",
  margin: "auto",
  position: "relative",
}

const Content = styled.div`
  ${fonts.openSans};
  max-width: 600px;
  margin: auto;
  text-align: center;
  font-size: 16px;
  padding: 20px 0;

  p {
    margin-bottom: 26px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    padding: 98px 0;
  }
`

const Title = styled.div`
  ${fonts.moretBold};
  font-size: 45px;
  color: ${colors.lightGreen};
  line-height: 1;
  margin-bottom: 26px;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 42px;
  }
`

const Subtitle = styled.div`
  font-weight: 700;
  text-transform: uppercase;
  margin: 26px auto;
`

const Close = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 20px;

  img {
    width: 20px;
    height: 20px;
  }

  @media (min-width: ${breakpoints.md}) {
    top: 40px;
    right: 40px;
  }
`

const RingSizerPopup = ({ open, handlePopup, t }) => {
  return (
    <ReactPopup
      open={open}
      overlayStyle={overlayStyle}
      contentStyle={contentStyle}
      closeOnDocumentClick
      closeOnEscape
      onClose={() => handlePopup(false)}
    >
      <div>
        <Close onClick={() => handlePopup(false)}>
          <img src={CloseIcon} alt="close popup" />
        </Close>
        <Content>
          <Title>{t("pdp.popup.sizer_title")}</Title>
          <Subtitle>{t("pdp.popup.sizer_subtitle")}</Subtitle>
          <p>{t("pdp.popup.sizer_paragraph_1")}</p>
          <p>{t("pdp.popup.sizer_paragraph_2")}</p>
        </Content>
      </div>
    </ReactPopup>
  )
}

export default withTranslation()(RingSizerPopup)
